import { useEffect } from 'react';
import { Toaster } from 'sonner';
import { initSmoothScroll } from './lib/scroll';
import Navbar from './components/site/Navbar';
import Hero from './components/site/Hero';
import Marquee from './components/site/Marquee';
import About from './components/site/About';
import Products from './components/site/Products';
import Quality from './components/site/Quality';
import Trust from './components/site/Trust';
import AgroTech from './components/site/AgroTech';
import Expansion from './components/site/Expansion';
import Contact from './components/site/Contact';
import Footer from './components/site/Footer';
import WhatsAppFloat from './components/site/WhatsAppFloat';

function App() {
  useEffect(() => {
    initSmoothScroll();
  }, []);

  return (
    <div className="min-h-screen bg-cream font-body text-ink" data-testid="app-root">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Products />
        <Quality />
        <Trust />
        <AgroTech />
        <Expansion />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
      <Toaster position="bottom-center" richColors />
    </div>
  );
}

export default App;
